import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Colours from '../../definitions/Colours';


function IconShield({ outlineWidth, stroke, strokeWidth, fill, ...otherProps }) {
    return (
        <IconShield.Svg
            viewBox="0 0 62 62"
            outlineWidth={outlineWidth}
            strokeColour={stroke}
            strokeWidth={strokeWidth}
            fillColour={fill}
            {...otherProps}
        >
            <circle
                cx="31"
                cy="31"
                r="29"
            />
            <path d="M30.49 47c12.75-4.68 12.63-20.2 12.63-20.2M43.14 26.77v-6.31a1 1 0 00-1-1h-2.09M30.49 47c-12.75-4.68-12.63-20.2-12.63-20.2M17.84 26.77v-6.31a1 1 0 011-1h2.1M21 19.46c6.92 0 9.49-4.41 9.49-4.41h.06s2.55 4.41 9.45 4.41M24.27 31.01h12.44M30.49 37.24V24.79" />
        </IconShield.Svg>
    );
}

IconShield.propTypes = {
    outlineWidth: PropTypes.string,
    stroke: PropTypes.oneOf(
        Object.values(Colours),
    ),
    strokeWidth: PropTypes.string,
    fill: PropTypes.oneOf(
        Object.values(Colours),
    ),
};

IconShield.defaultProps = {
    outlineWidth: '2px',
    stroke: Colours.BLACKBERRY,
    strokeWidth: '2px',
    fill: Colours.TRANSPARENT,
};

IconShield.Svg = styled.svg`
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: ${props => props.strokeWidth};
    stroke: ${props => props.strokeColour};
    fill: ${props => props.fillColour};

    circle {
        stroke-width: ${props => props.outlineWidth};
    }

    transition: 
        stroke 300ms ease,
        fill 300ms ease;
`;

export default IconShield;
